import React, { useContext } from 'react'

import PermissionErrorMessage from '../permissionErrorMessage'
import { AuthContext } from 'contexts/auth'
import { Permissions } from 'api'

export const IsPermitted = ({
  action,
  children,
  showError = false,
}: {
  action: string;
  children: any;
  showError?: boolean;
}) => {
// @ts-expect-error - TS2339 - Property 'authorization' does not exist on type 'unknown'.
  const { authorization } = useContext(AuthContext)

  return Permissions.isOperationPermitted(authorization, action) ? children : (showError ?
    <PermissionErrorMessage /> : null)
}
